// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-flex[data-v-2f9c60dc]{display:flex}.spacer[data-v-2f9c60dc]{width:20px}", ""]);
// Exports
module.exports = exports;
